import { RUBRIC_NAMES } from '../../constants/navbar/linkNames';
import { INavbarLink } from '../../types/navbar';
import { IApplicationState } from '../../types/redux';
import { IRubricsLinksState } from '../../types/rubricsLinks';
import { selectNavbarDefaultRubrics } from '../navbarDefaultRubrics';
import { selectRubricsLinks } from './selectRubricsLinks';

export function selectNavbarRubrics(state: IApplicationState): INavbarLink[] {
  const rubricLinks = selectRubricsLinks(state);
  const navbarDefaultRubrics = selectNavbarDefaultRubrics(state);
  const { activeRubric, hoveredRubric } = state.dropdown;

  const navBarLinks: INavbarLink[] = [];

  for (const rubric of navbarDefaultRubrics) {
    const navBarLink: INavbarLink = {
      hovered: hoveredRubric === rubric,
      active: activeRubric === rubric,
      rubric,
      title: RUBRIC_NAMES[rubric],
    };

    if (isNotSyntheticRubric(rubric, rubricLinks) && rubricLinks[rubric]) {
      navBarLink.url = rubricLinks[rubric];
    }

    navBarLinks.push(navBarLink);
  }

  return navBarLinks;
}

function isNotSyntheticRubric(rubric: string, rubricLinks: IRubricsLinksState): rubric is keyof IRubricsLinksState {
  return rubricLinks.hasOwnProperty(rubric);
}
